export const STATUS = {
  COMPLETE: "COMPLETE",
  PENDING: "PENDING",
  FAIL: "FAIL",
  PROCESSING: "PROCESSING",
};

export const STATUS_TITLE = {
  COMPLETE: "Complete",
  PENDING: "Pending",
  FAIL: "Fail",
  PROCESSING: "Processing",
};
